// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bb6774c3","703":"96a42a94"}[chunkId] + ".chunk.js";
};